import { cva } from 'class-variance-authority'

const spinnerVariants = cva('animate-spin', {
  variants: {
    size: {
      3: 'size-3',
      4: 'size-4',
      5: 'size-5',
      6: 'size-6',
      8: 'size-8'
    }
  },
  defaultVariants: {
    size: 4
  }
})

export { spinnerVariants }
